import * as d3 from 'd3';
import Api from "../Api";
import Thinker from "../components/Thinker";

const Treemap = function(options) {
    const container = $(options.container);

    const colors = [
        '#005868',
        '#005868',
        '#007186',
        '#0089A3',
        '#00A1B9',
        '#00A1B9',
        '#00B9D4',
        '#00CDEB',
        '#00CDEB',
        '#00CDEB',
    ];

    function render() {
        const margin = {top: 5, right: 5, bottom: 5, left: 5},
            width = container.width() - margin.left - margin.right,
            height = 600 - margin.top - margin.bottom;

        const svg = d3.select(options.svg)
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr('transform', `translate(${margin.left},${margin.top})`);

        Thinker.begin($(options.container));
        Api.send(container.data('url')).done(function (results) {
            Thinker.end($(options.container));

            const root = d3.stratify()
                .id(d => d.id)
                .parentId(d => d.app_id)
                (results);
            root.sum(d => +d.value);

            d3.treemap()
                .size([width, height])
                .padding(8)
                (root);


            svg.selectAll('rect')
                .data(root.leaves())
                .enter()
                .append('rect')
                .attr('x', d => d.x0)
                .attr('y', d => d.y0)
                .attr('width', d => d.x1 - d.x0)
                .attr('height', d => d.y1 - d.y0)
                // .style('stroke', 'black')
                .style('fill', (d, i) => colors[i]);

            svg.selectAll('foreignObject')
                .data(root.leaves())
                .enter()
                .append('foreignObject')
                .attr('x', d => d.x0)
                .attr('y', d => d.y0)
                .attr('width', d => d.x1 - d.x0)
                .attr('height', d => d.y1 - d.y0)
                .append('xhtml:div')
                .style('width', '100%')
                .style('height', '100%')
                .html(d => `<a class="tree-node-link" href="${d.data.link}"><span>${d.data.title} (${d.data.value} completed)</span></a>`);
        });
    }

    setTimeout(function () {
        render();
    }, 100);

    function update() {
        $(options.svg).empty();
        setTimeout(function () {
            render();
        }, 500);
    }

    // $('body').on('click', '.hamburger a', function () {
    //     $(options.container).trigger('update');
    // });

    $(options.container).on('update', function () {
        update();
    });
};

export default Treemap;